import { render, staticRenderFns } from "./SelectedLicenceList.vue?vue&type=template&id=49f676ac&scoped=true&"
import script from "./SelectedLicenceList.vue?vue&type=script&lang=ts&"
export * from "./SelectedLicenceList.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedLicenceList.vue?vue&type=style&index=0&id=49f676ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f676ac",
  null
  
)

export default component.exports